import React, { Fragment, useState, useEffect } from "react";
import { Link } from "gatsby";
import AuthorNames from "../author-names";
import SidebarSection from "./sidebar-section";
import SidebarItem from "./sidebar-item";
import { StatusType } from "../../services/firebase/auth-context/reducer";
import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../../../tailwind.config";
import Icon, { IconName } from "../icon";
import Modal from "../common/modal";
import useCmsEvents from "../../hooks/use-cms-events";
import DOMWindow from "../../util/dom-wrapper/window";
var AllSidebarSections = function AllSidebarSections(_ref) {
    var edition = _ref.edition, categoryName = _ref.categoryName, readArticles = _ref.readArticles, renderEvents = _ref.renderEvents;
    return /*#__PURE__*/ React.createElement("div", {
        className: "h-full overflow-auto w-full mb-12 block lg:mb-0 lg:block lg:w-1/3 lg:pr-4"
    }, edition.sections.map(function (section, index) {
        return /*#__PURE__*/ React.createElement(SidebarSection, {
            heading: categoryName(section.category),
            headClassName: "text-black",
            backgroundColor: "bg-makroBlueLight",
            key: index
        }, /*#__PURE__*/ React.createElement(React.Fragment, null, section.articles.map(function (article, index) {
            return /*#__PURE__*/ React.createElement(SidebarItem, {
                key: index,
                to: "/" + edition.slug + "/" + article.slug + "/",
                read: readArticles && readArticles.includes(article.id),
                title: article.title,
                articleId: article.id,
                visibility: article.visibility
            }, /*#__PURE__*/ React.createElement(AuthorNames, {
                authors: article.authors,
                link: false
            }));
        })));
    }), renderEvents(), /*#__PURE__*/ React.createElement(Link, {
        to: "/alle-ausgaben/",
        className: "w-24 block relative ml-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "absolute left-0 right-0 font-bold text-center text-white z-20 leading-tight text-xs",
        style: {
            top: "21px",
            paddingRight: "20px"
        }
    }, "WEITERE AUSGABEN"), /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.MAGNIFIER
    })));
};
var EditionSidebar = function EditionSidebar(_ref2) {
    var edition = _ref2.edition, authContext = _ref2.authContext;
    var _authContext$ = authContext[0], userData = _authContext$.userData, authenticated = _authContext$.authenticated;
    var _useState = useState(false), sidebarState = _useState[0], setSidebarState = _useState[1];
    useEffect(function () {
        var onResize = function onResize() {
            var cssFullConfig = resolveConfig(tailwindConfig);
            if (DOMWindow.innerWidth() >= parseInt(cssFullConfig.theme.screens.lg)) {
                setSidebarState(false);
            }
        };
        DOMWindow.addEventListener("resize", onResize);
        return function () {
            return DOMWindow.removeEventListener("resize", onResize);
        };
    }, []);
    var readArticles = authenticated && userData.status === StatusType.SUCCESS && userData.data.readArticles;
    var eventsData = useCmsEvents();
    var renderEvents = function renderEvents() {
        if (eventsData.allDatoCmsEvent.edges.length > 0) {
            return /*#__PURE__*/ React.createElement(SidebarSection, {
                heading: "VERANSTALTUNGEN",
                backgroundColor: "bg-makroBlueLight",
                headClassName: "text-makroOrange"
            }, /*#__PURE__*/ React.createElement(React.Fragment, null, eventsData.allDatoCmsEvent.edges.map(function (event, index) {
                return /*#__PURE__*/ React.createElement(SidebarItem, {
                    to: "/veranstaltung/" + event.node.slug,
                    title: event.node.title,
                    key: index,
                    isEvent: true
                }, /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("div", {
                    className: "text-base"
                }, event.node.time, " Uhr"), /*#__PURE__*/ React.createElement("div", {
                    className: event.node.locationName ? "mt-1 text-base" : ""
                }, event.node.locationName), /*#__PURE__*/ React.createElement("div", {
                    className: "mt-1"
                }, event.node.shortDescription)));
            })));
        }
    };
    var renderEditionNav = function renderEditionNav() {
        return /*#__PURE__*/ React.createElement("div", {
            className: "border-t-8  border-solid border-makroOrange mb-6"
        }, "PREV NEXT");
    };
    var categoryName = function categoryName(category) {
        return category && category.name ? category.name : "";
    };
    var categoryColor = function categoryColor(category) {
        return category && category.color ? category.color : "Orange";
    };
    var toggleSidebar = function toggleSidebar() {
        setSidebarState(!sidebarState);
    };
    return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("button", {
        className: "fixed px-2 left-0 font-bold text-center text-sm text-white shadow-md rounded-b transform -rotate-90 z-30 bg-makroOrange lg:hidden",
        style: {
            top: "50%",
            width: "128px",
            height: "22px",
            marginTop: "-32px",
            marginLeft: "-54px"
        },
        onClick: toggleSidebar
    }, "Inhaltsverzeichnis"), /*#__PURE__*/ React.createElement("div", {
        className: "hidden lg:contents"
    }, /*#__PURE__*/ React.createElement(AllSidebarSections, {
        edition: edition,
        categoryName: categoryName,
        readArticles: readArticles,
        renderEvents: renderEvents
    })), /*#__PURE__*/ React.createElement("div", {
        className: "block lg:hidden"
    }, /*#__PURE__*/ React.createElement(Modal, {
        isOpen: sidebarState,
        onRequestClose: toggleSidebar
    }, /*#__PURE__*/ React.createElement("div", {
        className: "font-bold text-xl pr-10 pb-3"
    }, "AUSGABE ", edition.label), /*#__PURE__*/ React.createElement(AllSidebarSections, {
        edition: edition,
        categoryName: categoryName,
        readArticles: readArticles,
        renderEvents: renderEvents
    }))));
};
export default EditionSidebar;
